const unknownStatus: number = 999;

export class RuntimeException {
    readonly #msg: string;
    readonly #code: number;

    constructor( msg: string, code?: number ) {
        this.#msg = msg;
        this.#code = code ?? unknownStatus;
    }

    get message (): string {
        return this.#msg;
    }

    get code(): number {
        return this.#code;
    }
}

export class Unknown extends RuntimeException {
    static get statusCode(): number {
        return unknownStatus;
    }

    constructor( trace: string ) {
        super( trace );
    }
}

export class ConfigurationError extends RuntimeException {
    private static readonly _status: number = 0;

    constructor( msg: string ) {
        super( msg, ConfigurationError._status );
    }

    static get statusCode(): number {
        return ConfigurationError._status;
    }
}

class MissingData extends Error {
    constructor( ...params: any[] ) {
        // Pass remaining arguments (including vendor specific ones) to parent constructor
        super( ...params );

        // Maintains proper stack trace for where our error was thrown (only available on V8)
        if ( Error.captureStackTrace ) {
            Error.captureStackTrace( this, MissingData );
        }

        this.name = "MissingData";
    }
}